module.exports = __webpack_public_path__ + "img/aaron_promo.8ce0cb15.png";